export default {
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      variant: "outlined",
    },
    styleOverrides: {
      root: {
        label: {
          top: "-4px",
        },
      },
    },
  },
};
